import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppState } from "../state/app.state";
import { Observable } from "rxjs";
import { Response } from "../models/response.model";
import { DashboardMessage } from "../models/dashboard.model";
import { DashboardDetail } from "../models/dashboard-detail.model";
import { InventoryCoordinate } from "../models/inventory-coordinate.model";
import { DashboardSetting } from "../models/dashboardSetting.model";
import { Module } from "../models/module.model";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(
    private appState: AppState,
    private http: HttpClient) {
  }

  getMessages(): Observable<DashboardMessage[]> {
    return this.http.get<Response>(`${this.appState.baseApiUrl}/dashboard/messages`, httpOptions).pipe(
      map((response: Response) => {
        if (!response.Success) return;
        return response.Data;
      }),
    );
  }

  getCounters(): Observable<DashboardDetail> {
    return this.http.get<DashboardDetail>(`${this.appState.baseApiUrl}/dashboard/counters`, httpOptions)
  }

  getInventoryCoordinates(): Observable<InventoryCoordinate[]> {
    return this.http.get<InventoryCoordinate[]>(`${this.appState.baseApiUrl}/dashboard/coordinates`, httpOptions)
  }

  getWoDashboard(): Observable<DashboardSetting[]> {
    return this.http.get<DashboardSetting[]>(`${this.appState.baseApiUrl}/dashboard/settings`, httpOptions)
  }

  updateWoDashboard(items: DashboardSetting[]): Observable<Response> {
    return this.http.put<Response>(`${this.appState.baseApiUrl}/dashboard/settings`, items, httpOptions)
  }

  getModules(): Observable<Response> {
    return this.http.get<Response>(`${this.appState.baseApiUrl}/dashboard/modules`, httpOptions)
  }

}
